import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { DeleteMasterDataDeductionTypesDTO } from "@src/domain/dto/masterData";

export class DeleteMasterDataDeductionTypesUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(params: DeleteMasterDataDeductionTypesDTO) {
    return this.repository.deleteDeductionTypes(params);
  }
}
